import { customFetch } from '../../lib/utils';
import { Notification } from './types';

// ONLY unread user-specific notifications
const getUnreadUserNotifications = async ({
  accessToken
}: {
  accessToken: string;
}): Promise<Notification[]> => {
  const res = await customFetch('/backend/notifications/unread', {
    headers: {
      Authorization: `Bearer ${accessToken}`
    }
  });

  return await res.json();
};

// ALL user notifications. including teams and global
const getAllUserNotifications = async ({
  accessToken
}: {
  accessToken: string;
}): Promise<Notification[]> => {
  const res = await customFetch('/backend/notifications', {
    headers: {
      Authorization: `Bearer ${accessToken}`
    }
  });

  return await res.json();
};

const readNotification = async ({
  accessToken,
  updateId
}: {
  accessToken: string;
  updateId: string;
}): Promise<void> => {
  const res = await customFetch(`/backend/notifications/${updateId}/read`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${accessToken}`
    }
  });

  return await res.json();
};

export {
  getAllUserNotifications,
  readNotification,
  getUnreadUserNotifications
};
